'use client'
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/layout';
import { Button, FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';
import { forwardRef } from '@chakra-ui/system';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
const NewExperienceGroupInSharedExperienceForm = forwardRef((props, ref) => {
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
    sharedExperienceId,
    groupId
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isValid }
  } = useForm();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      if (name) {
        await sharedExperiencesApi.createExperienceGroup(
          name,
          sharedExperienceId,
          groupId
        );
      }
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error('Error in newExperienceGroupInSharedExperienceForm:', e);
    }
  };
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid, onValidityChange]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <FormControl isInvalid={errors && errors.name} mb={3}>
            <FormLabel>Group Name</FormLabel>
            <Input
              placeholder='Group name'
              {...register('name', {
                required: true,
                minLength: 3
              })}
            />
            <FormErrorMessage>{errors && errors.name}</FormErrorMessage>
          </FormControl>
          <Button
            style={{
              display: hideSave ? 'none' : 'inherit',
            }}
            ref={ref}
            isLoading={isSubmitting}
            isDisabled={!isValid}
            type='submit'
            my={2}
          >Save</Button>
        </form>
      </Box>
    </>
  );
});
export default NewExperienceGroupInSharedExperienceForm; 